$(window).scroll(function () {
var scroll = $(window).scrollTop();
if (scroll < 200) {
$('.fixed-top').css({
"background": "#fff0",
"box-shadow": "none"
});
} else {
$('.fixed-top').css({
"background": "#001601",
"box-shadow": "9px 11px 31px -1px rgb(0 0 0 / 60%)"

});
}
});
//products slider

         var owl = $('.product_slider');
owl.owlCarousel({
loop:true,
margin:8,
nav:true,
dots:true,
navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
autoplay: 3000,
smartSpeed: 1000,
stagepadding:20,
responsive:{
0:{
items:2
},
600:{
items:2
},
1000:{
items:2
}
}
});  
   



//Client slider
var owl = $('.client_slider');
owl.owlCarousel({
loop:true,
margin:8,
nav:true,
dots:true,
navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
autoplay: 3000,
smartSpeed: 1000,
stagepadding:20,
responsive:{
0:{
items:1
},
600:{
items:1
},
1000:{
items:4
}
}
});  


$(document).ready(function() {
$(document).scroll(function() {
if ($(document).scrollTop() >= 25) {
$('.mobile_header').addClass('js-scrolling');
} else {
$('.mobile_header').removeClass('js-scrolling');
}
});
});      

// products slider
var owl = $('.shop-cat_slider');
owl.owlCarousel({
    items:1,
    loop:true,
    margin:10,
    //navText: [
     // "<img src='image/arrow-left.png'>",
    //  "<img src='image/arrow-right.png'>",
    //],
    autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:true,
    responsive:{
        0:{
        items:2
        },
        600:{
        items:2
        },
        1000:{
        items:2
        }
        }
});
$('.play').on('click',function(){
    owl.trigger('play.owl.autoplay',[5000])
});
$('.stop').on('click',function(){
    owl.trigger('stop.owl.autoplay')
});
(() => {
        
    const openNavMenu = document.querySelector(".open-nav-menu"),
       closeNavMenu = document.querySelector(".close-nav-menu"),
       navMenu = document.querySelector(".nav-menu"),
       menuOverlay = document.querySelector(".menu-overlay"),
       mediaSize = 991;
 
    openNavMenu.addEventListener("click", toggleNav);
    closeNavMenu.addEventListener("click", toggleNav);
    // close the navMenu by clicking outside
    menuOverlay.addEventListener("click", toggleNav);
 
    function toggleNav() {
       navMenu.classList.toggle("open");
       menuOverlay.classList.toggle("active");
       document.body.classList.toggle("hidden-scrolling");
    }
 
    navMenu.addEventListener("click", (event) => {
       if (event.target.hasAttribute("data-toggle") &&
          window.innerWidth <= mediaSize) {
          // prevent default anchor click behavior
          event.preventDefault();
          const menuItemHasChildren = event.target.parentElement;
          // if menuItemHasChildren is already expanded, collapse it
          if (menuItemHasChildren.classList.contains("active")) {
             collapseSubMenu();
          } else {
             // collapse existing expanded menuItemHasChildren
             if (navMenu.querySelector(".menu-item-has-children.active")) {
                collapseSubMenu();
             }
             // expand new menuItemHasChildren
             menuItemHasChildren.classList.add("active");
             const subMenu = menuItemHasChildren.querySelector(".sub-menu");
             subMenu.style.maxHeight = subMenu.scrollHeight + "px";
          }
       }
    });
 
    function collapseSubMenu() {
       navMenu.querySelector(".menu-item-has-children.active .sub-menu")
          .removeAttribute("style");
       navMenu.querySelector(".menu-item-has-children.active")
          .classList.remove("active");
    }
 
    function resizeFix() {
       // if navMenu is open ,close it
       if (navMenu.classList.contains("open")) {
          toggleNav();
       }
       // if menuItemHasChildren is expanded , collapse it
       if (navMenu.querySelector(".menu-item-has-children.active")) {
          collapseSubMenu();
       }
    }
 
    window.addEventListener("resize", function () {
       if (this.innerWidth > mediaSize) {
          resizeFix();
       }
    });
 
 })();


 